var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmxColorHoriz = function SvgSmxColorHoriz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 958.351 314.928"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".smx-color-horiz_svg__cls-1{fill:#303cbf}"))), /*#__PURE__*/React.createElement("g", {
    id: "smx-color-horiz_svg__smx-color-horiz",
    transform: "translate(-136.5 -270.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smx-color-horiz_svg__Group_1991",
    "data-name": "Group 1991",
    transform: "translate(136.5 270.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smx-color-horiz_svg__Group_1977",
    "data-name": "Group 1977"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "smx-color-horiz_svg__Path_2111",
    "data-name": "Path 2111",
    className: "smx-color-horiz_svg__cls-1",
    d: "M111.075 657.617 178.6 647.9a4.722 4.722 0 0 1 5.4 4.453l3.25 68.114a4.726 4.726 0 0 1-7.734 3.867l-70.778-58.365a4.75 4.75 0 0 1 2.337-8.352Z",
    transform: "translate(-72.242 -437.32)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "smx-color-horiz_svg__Path_2112",
    "data-name": "Path 2112",
    d: "M171.128 152.541 163.816 0 0 198.492l151.142-21.773a23.277 23.277 0 0 0 19.986-24.178Z",
    style: {
      fill: "#4dbbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "smx-color-horiz_svg__Path_2113",
    "data-name": "Path 2113",
    d: "M479.786 416.026a29.185 29.185 0 0 1-24.99 30.287l-19.6 2.827 5.524 115.137a4.752 4.752 0 0 0 8.417 2.795l148.189-179.546a4.757 4.757 0 0 0-4.355-7.734l-114.1 16.444Z",
    transform: "translate(-293.774 -256.335)",
    style: {
      fill: "#4d61ff"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "smx-color-horiz_svg__Path_2123",
    "data-name": "Path 2123",
    className: "smx-color-horiz_svg__cls-1",
    d: "M145.914 34.317q0 17.447-8.925 30.2t-24.9 19.528q-15.971 6.778-36.639 6.778-5.771 0-14.159-.738a159.874 159.874 0 0 1-22.279-4.093A174.853 174.853 0 0 1 10.09 76.06V30.425A204.033 204.033 0 0 0 37.808 44.92 74.05 74.05 0 0 0 67 50.691q14.36 0 18.588-4.764T89.814 37q0-7.516-7.247-12.683T61.5 13.649A166.668 166.668 0 0 1 34.654-.376 63.591 63.591 0 0 1 15.8-19.367Q8.483-30.775 8.483-46.343a51.3 51.3 0 0 1 7.382-27.177q7.382-12.146 22.547-19.393t37.042-7.247a129.222 129.222 0 0 1 28.788 3.02 124.641 124.641 0 0 1 21.809 6.778 86.941 86.941 0 0 1 11.81 5.905v43.617a153.043 153.043 0 0 0-25.433-14.629 71 71 0 0 0-30-6.442q-10.468 0-15.166 4.026a12.58 12.58 0 0 0-4.7 9.932 12.192 12.192 0 0 0 4.7 9.529q4.7 4.026 16.776 9.8A335.092 335.092 0 0 1 118.4-10.509q12.884 8.053 20.2 18.588t7.314 26.238ZM372.889 88.4h-56.1V-19.367l-50.6 62.408h-4.429l-50.727-62.408V88.4h-54.49V-97.611h50.865l57.173 69.789 57.442-69.789h50.865Zm240.52 0h-72.071L521.61 65.051q-.939-1.342-11.676-14.293t-14.227-17.649Q479.6 54.851 469.4 67.467L452.357 88.4h-71l78.919-96.762-75.292-89.249h71.668L469.4-82.043q11.005 13.555 26.305 33.821Q510.336-69.7 519.06-80.03l14.629-17.581h70.326l-72.34 89.249Z",
    transform: "translate(481.442 494.324)"
  }))));
};

export default SvgSmxColorHoriz;